<kpa-loader *ngIf="!isLoading"></kpa-loader>
<kendo-grid
	id="completedTaskGrid"
	kpaGrid
	[data]="gridData"
	[pageSize]="gridSettings.state.take"
	[skip]="gridSettings.state.skip"
	[sort]="gridSettings.state.sort"
	[filter]="gridSettings.state.filter"
	(dataStateChange)="dataStateChange($event)"
	[pageable]="true"
	(columnResize)="onResizeColumn($event)"
	(columnVisibilityChange)="onVisibilityChange($event)"
	[filterable]="false"
	[sortable]="true"
	[reorderable]="false"
	[resizable]="true"
	[loading]="isLoading"
	[columnMenu]="{ filter: false, sort: false }"
	class="card card-grid kpa-grid kpa-completed-tasks-grid">
	<kendo-grid-column
		*ngFor="let col of gridSettings.columnsConfig"
		[field]="col.field"
		[title]="col.title"
		[width]="col.width"
		[filter]="col.filter"
		[filterable]="col.filterable"
		[hidden]="col.hidden"
		[format]="col.format"
		[locked]="col.locked"
		class="col.class"
		[sortable]="col.sortable"
		[minResizableWidth]="col.minResizableWidth">
		<ng-template
			kendoGridCellTemplate
			let-dataItem
			let-rowIndex="rowIndex"
			let-columnIndex="columnIndex">
			<div *ngIf="col.field === 'title'">
				<span
					id="grid_completedTaks_column_Title_r{{ rowIndex }}c{{ columnIndex }}"
					[ngClass]="isDisabled(dataItem)	? 'title-disabled' : 'title' "
					(click)="!isDisabled(dataItem) && openTask(dataItem)">
					{{ dataItem.title }}
				</span>
			</div>
			<div *ngIf="col.field === 'type'">
				<span id="grid_completedTaks_column_Type_r{{ rowIndex }}c{{ columnIndex }}">
					{{ getContentType(dataItem.type, dataItem.contentType) }}
				</span>
			</div>
			<div *ngIf="col.field === 'completed'">
				<span id="grid_completedTaks_column_Completed_r{{ rowIndex }}c{{ columnIndex }}">
					{{ dataItem.completed | date: 'MM/dd/yy' }}
				</span>
			</div>
			<div *ngIf="col.field === 'Downloads'">
				<span
					id="grid_completedTaks_column_Downloads_r{{ rowIndex }}c{{ columnIndex }}"
					class="download"
					(click)="GetCertificate(dataItem)">
					<kendo-svgicon
						[icon]="downloadIcon"
						[size]="'medium'"></kendo-svgicon>
				</span>
			</div>
		</ng-template>
	</kendo-grid-column>

	<ng-template kendoGridNoRecordsTemplate>
		{{ noDataFoundGridText }}
	</ng-template>
</kendo-grid>

<kpa-offlinedocs
	[dialogOpened]="isOfflineTrainingDocs"
	[offlineAttachments]="completedOfflineAttachments"
	(closeDialog)="closeDialog()">
</kpa-offlinedocs>
